// extracted by mini-css-extract-plugin
export default {"pageContainer":"style_pageContainer__bs1h9","leftContainer":"style_leftContainer__CcLhk","svgContainer":"style_svgContainer__x1BFo"};